import * as yup from 'yup'

export const schema = {
  title: '',
  reviewContent: '',
  name: '',
  location: '',
  ratingSelected: 0
}

export const validation = () => {
  return (
    yup
      .object()
      .shape({
        title: yup
          .string()
          .required('Required'),

        reviewContent: yup
          .string()
          .required('Required'),

        name: yup
          .string()
          .required('Required'),

        location: yup
          .string(),

        ratingSelected: yup
          .number()
          .required('Required')
      })
  )
}
